import { Announcement } from '../types';
import { mockAnnouncements } from '../data/mockData';
import api from './api';

const USE_MOCK = process.env.REACT_APP_USE_MOCK !== 'false';

export async function fetchAnnouncements(activeOnly = true): Promise<Announcement[]> {
  if (USE_MOCK) {
    await new Promise((r) => setTimeout(r, 200));
    const now = new Date().toISOString();
    return mockAnnouncements.filter((a) => {
      if (activeOnly && !a.active) return false;
      if (a.expiresAt && a.expiresAt < now) return false;
      return true;
    });
  }
  const { data } = await api.get<Announcement[]>('/announcements', {
    params: { active: activeOnly },
  });
  return data;
}
